import React from "react"

export default function Youtube(props) {
    // return (
    //     <div className={yts.videowrap}>
    //         <p>{JSON.stringify(props.link)}</p>
    //         <iframe width="560" height="315" src={`https://www.youtube.com/embed/${props.link}`}
    //             frameborder="0" allowfullscreen title="props.-."></iframe>
    //     </div>

    // );
    return <p>{props}</p>
}